import React, { useEffect, useState, useRef } from "react";
import { getTodayBookings } from "../api";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import dayjs from "dayjs";
import "../styles/ArrivalsDeparturesBoard.css";

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const id = setInterval(() => savedCallback.current(), delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

const ArrivalsDeparturesBoard = () => {
  const [arrivals, setArrivals] = useState([]);
  const [departures, setDepartures] = useState([]);
  const [secondsLeft, setSecondsLeft] = useState(60);

  const fetchBookings = async () => {
    try {
      const bookings = await getTodayBookings();

      const inBookings = bookings
        .filter((b) => b.booking_type.toLowerCase() === "in")
        .sort((a, b) => new Date(b.date + " " + b.time) - new Date(a.date + " " + a.time));

      const outBookings = bookings
        .filter((b) => b.booking_type.toLowerCase() === "out")
        .sort((a, b) => new Date(b.date + " " + b.time) - new Date(a.date + " " + a.time));

      setArrivals(inBookings);
      setDepartures(outBookings);
      setSecondsLeft(60);
    } catch (err) {
      console.error("Error loading bookings:", err);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  // Refresh data every minute
  useInterval(fetchBookings, 60000);

  // Countdown display
  useInterval(() => {
    setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
  }, 1000);

  const renderBoard = (title, icon, data) => (
    <div className="board-section">
      <div className="board-header">
        {icon}
        <h2>{title}</h2>
      </div>
      <div className="board-table">
        <div className="board-row header">
          <div className="cell">Time</div>
          <div className="cell">Destination</div>
          <div className="cell">Registration</div>
        </div>
        {data.map((b, i) => (
          <div key={i} className="board-row flip">
            <div className="cell">{b.time}</div>
            <div className="cell">{b.location || "-"}</div>
            <div className="cell">{b.registration?.toUpperCase()}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="arrivals-departures-container">
      <div className="countdown">Refreshing in {secondsLeft}s</div>
      {renderBoard("ARRIVALS", <FlightLandIcon className="icon" />, arrivals)}
      {renderBoard("DEPARTURES", <FlightTakeoffIcon className="icon" />, departures)}
    </div>
  );
};

export default ArrivalsDeparturesBoard;
